/* eslint-disable no-case-declarations */
/* eslint-disable no-redeclare */
/* eslint-disable prefer-destructuring */
/* eslint-disable eqeqeq */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import { getFrameAfterRotate } from '@src/slide/infrastructure/module/independent/graphic';
import GroupModel from '@src/slide/domain/ui-model/element-modeles/group-model';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { observable } from 'mobx';
import * as constraints from '@editor/src/page/index/components/canvas/constraints';
import SnaplineLogic from '@src/framework/editor/src/page/index/components/canvas/snapline-logic';
import { SelectedEleMgrType } from '@src/slide/domain/selection/constant/select-element-type';
import { MODES } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import has from 'lodash/has';
import get from 'lodash/get';

export default class SnaplineManager {
    @observable activeSnapLines = [];

    static getInstance() {
        if (!SnaplineManager.instance) {
            SnaplineManager.instance = new SnaplineManager();
        }
        return SnaplineManager.instance;
    }

    constructor() {
        this.snapLines = null;
    }

    getActiveSnapLines = () => this.activeSnapLines.slice();

    getGroutSnapLines = (modle) => {
        const rects = [];
        if (has(modle, 'children') && modle.children.length > 0) {
            const childenOfGroup = modle.children;
            for (let i = 0; i < childenOfGroup.length; i++) {
                const { selectedArray } = this.getSelectionService()?.selectedElements || {};
                let index = -1;
                if (selectedArray && selectedArray.length > 0) {
                    index = selectedArray.findIndex(currentValue => (currentValue.key === childenOfGroup[i].key));
                }
                if (index === -1) {
                    rects.push(childenOfGroup[i].getFrame?.().frameOnSlide());
                    if (childenOfGroup[i] instanceof GroupModel) {
                        rects.concat(this.getGroutSnapLines(childenOfGroup[i]));
                    }
                }
            }
        }
        return rects;
    };

    getSnapLines = () => {
        let rects = [];
        const { slideWidth, slideHeight } = this.getUiDataService().presentation.props;
        const selectedGroupElements = this.getSelectionService()?.selectedElements
            .selectedArrayForType(SelectedEleMgrType.GROUP);
        const groupLen = selectedGroupElements ? selectedGroupElements.length : 0;
        let groupid = '';
        if (groupLen > 0) {
            groupid = selectedGroupElements[0].parent.key;
        }

        // step1 遍历当前slide 除选中以外的元素
        this.getSelectionService()?.currentSlide?.children.forEach((child) => {
            const { selectedArray } = this.getSelectionService().selectedElements;
            let index = -1;
            if (selectedArray && selectedArray.length > 0) {
                index = selectedArray.findIndex(currentValue => (currentValue.key === child.key));
            }
            if (index === -1) {
                const childModel = child;
                // step2 把当前元素加入array
                if (groupid != childModel.key) {
                    rects.push({
                        left: has(childModel, 'props.style.left') ? childModel.props.style.left : 0,
                        top: has(childModel, 'props.style.top') ? childModel.props.style.top : 0,
                        width: has(childModel, 'props.style.width') ? childModel.props.style.width : 0,
                        height: has(childModel, 'props.style.height') ? childModel.props.style.height : 0,
                    });
                }
                // step3 把group和子元素依次加入array
                if (childModel instanceof GroupModel) {
                    const childRects = this.getGroutSnapLines(childModel);
                    rects = rects.concat(childRects);
                }
            }
        });

        // step4 把slide加入array
        rects.push({
            top: 0,
            left: 0,
            width: slideWidth,
            height: slideHeight,
            source: 'slide',
        });

        const snaplines = constraints.rectsToSnapLines(rects);
        return snaplines;
    };

    /**
    * 获取旋转90°的倍数时，可能贴到对齐线的mode
    * @param lists 方向数组
    * @param mode 鼠标作用的是哪个方向的点
    * @returns
    */
    getRotate90ModeList(lists, mode) {
        let modeList = [];
        const index = lists.indexOf(mode);
        if (index !== -1) {
            modeList = lists.slice(0, index).concat(lists.slice(index + 1));
        }
        return modeList;
    }

    /**
    * 旋转角度后，获取可能贴到对齐线的mode
    * @param rotate 旋转的角度
    * @param mode 鼠标作用的是哪个方向的点
    * @returns 可能出现对齐线的所有其他mode list
    */
    getRotateModeList(rotate, mode) {
        let modeList = [];
        if (rotate % 90 === 0) {
            modeList = this.getRotate90ModeList([MODES.TOP, MODES.RIGHT, MODES.BOTTOM, MODES.LEFT], mode);
            if (modeList.length === 0) {
                modeList = this.getRotate90ModeList([MODES.TOP_RIGHT, MODES.BOTTOM_RIGHT,
                    MODES.BOTTOM_LEFT, MODES.LEFT, MODES.TOP_LEFT], mode);
            }
        } else {
            // 旋转之后,缩放某一mode，上/下/左/右都可能出现对齐线
            const tempModeList = {
                [MODES.LEFT]: [MODES.TOP, MODES.BOTTOM_RIGHT],
                [MODES.RIGHT]: [MODES.TOP, MODES.BOTTOM_LEFT],
                [MODES.TOP]: [MODES.LEFT, MODES.BOTTOM_RIGHT],
                [MODES.BOTTOM]: [MODES.LEFT, MODES.TOP_RIGHT],
                [MODES.TOP_RIGHT]: [MODES.BOTTOM_LEFT],
                [MODES.BOTTOM_RIGHT]: [MODES.TOP_LEFT],
                [MODES.BOTTOM_LEFT]: [MODES.TOP_RIGHT],
                [MODES.BOTTOM_RIGHT]: [MODES.TOP_LEFT],
            }[mode];
            if (tempModeList) {
                modeList = tempModeList;
            }
        }
        return modeList;
    }

    /**
        * 处理单个元素获取lines
        * @param {event} e 鼠标事件
        * @param {object} outer 形状最层轮廓信息
        * @param {string} mode 鼠标作用的是哪个方向的点
        * @param {number} rotate 旋转状态
        * @returns {array} 对齐线的信息
    */
    getSingleEleLines = (outer, mode, rotate, nextSize) => {
        let newMode = mode;
        let newLines = this.runConstraints(outer, mode);
        if (newLines?.length === 0) {
            let modeList = [];
            if (SnaplineLogic.hasRotate(rotate)) {
                modeList = this.getRotateModeList(rotate, mode);
            } else {
                const groupChildrenRotate = SnaplineLogic.getRotateForGroupChildren(nextSize);
                if (SnaplineLogic.hasRotate(groupChildrenRotate)) {
                    modeList = this.getRotateModeList(groupChildrenRotate, mode);
                }
            }
            for (let index = 0; index < modeList.length; index++) {
                const tempLines = this.runConstraints(outer, modeList[index]);
                if (tempLines?.length > 0) {
                    newLines = tempLines;
                    newMode = modeList[index];
                    break;
                }
            }
        }
        return { newLines, newMode };
    };

    runConstraints = (nextSize, mode) => {
        // constraints在minWidth，minHeight生效且在两条辅助线之间，无法缩小
        // http://tapd.oa.com/TIM_web/bugtrace/bugs/view/101014386107744929
        const constrained = constraints.constrainWidthHeight(nextSize, 5, 5, mode);
        const results = constraints.constrainGrid(constrained, this.snapLines, mode);
        this.clear();
        this.activeSnapLines.push(...results.lines);
        return results.lines;
    };

    handleDragResizeStop = () => {
        this.clear();
    };

    calculateSnapLines = () => {
        this.snapLines = this.getSnapLines();
        this.clear();
    };

    clear = () => {
        this.activeSnapLines.clear();
    };

    getMultiRect = () => {
        const array = this.getSelectionService()?.selectedElements.selectedArray;
        let rect = null;
        if (array && array.length > 0) {
            rect  = this.caculateGroupFrame(this.getSelectionService().selectedElements.selectedArray);
        }
        if (!rect) {
            window.log.info('snaplineManager getMultiRect ==> rect is null');
        }
        return  rect ? {
            left: rect.left,
            top: rect.top,
            width: rect.width,
            height: rect.height,
            length: array.length,
        }
            : null;
    };

    // 算出外边框
    caculateGroupFrame = (selectedElements) => {
        const elements = selectedElements;
        const { left, top, width, height } = elements[0].getFrame().outerFrameOnSlide();

        const frame = {
            left,
            top,
            right: left + width,
            bottom: top + height,
        };
        for (const iterator of elements) {
            const { left, top, width, height } = iterator.getFrame().outerFrameOnSlide();

            frame.left    = frame.left < left ? frame.left : left;
            frame.top     = frame.top < top ? frame.top : top;
            frame.right   = frame.right < (left + width) ? (left + width)  : frame.right;
            frame.bottom  = frame.bottom < (top + height)  ? (top + height)  : frame.bottom;
        }
        const rect = {
            left: frame.left,
            top: frame.top,
            width: frame.right - frame.left,
            height: frame.bottom - frame.top,
        };
        return rect;
    };

    /**
     * 单选页面中的组合元素
     */
    isSingleGroupSelected = () => {
        const selectedSlideElements = this.getSelectionService()?.selectedElements
            .selectedArrayForType(SelectedEleMgrType.SLIDE);
        const selectedGroupElements = this.getSelectionService()?.selectedElements
            .selectedArrayForType(SelectedEleMgrType.GROUP);
        const slideLen = selectedSlideElements ? selectedSlideElements.length : 0;
        const groupLen = selectedGroupElements ? selectedGroupElements.length : 0;
        return slideLen === 1 && groupLen < 1 && selectedSlideElements[0] instanceof GroupModel;
    };

    caculateOffsetFrame = (e, elementModel, originalSize, nextSize, mode, mutiRect = {
        left: 0, top: 0, width: 0, height: 0,
    }, offsetFrame) => {
        const isGroupChildren = elementModel?.parent?.type === UIModelType.GROUP;
        let original = getFrameAfterRotate(originalSize, elementModel.props.style.rotate);
        let outer = getFrameAfterRotate(nextSize, elementModel.props.style.rotate);

        if (isGroupChildren) {
            const frameOnSlide = elementModel.getFrame?.().frameOnSlide();
            // frameOnSlide = getFrameAfterRotate(frameOnSlide,360 - elmentWrapper.element.parent.props.style.rotate);
            const ori = originalSize;
            const nxt = nextSize;
            const change = {
                left: nxt.left - ori.left,
                top: nxt.top - ori.top,
                width: nxt.width - ori.width,
                height: nxt.height - ori.height,
            };


            originalSize = frameOnSlide;

            nextSize = elementModel.getFrame?.().frameOnSlide({
                left: elementModel.props.style.left + change.left,
                top: elementModel.props.style.top + change.top,
                width: elementModel.props.style.width + change.width,
                height: elementModel.props.style.height + change.height,
                rotate: elementModel.props.style.rotate,
                flipH: nxt.flipH,
                flipV: nxt.flipV,
            });

            original = getFrameAfterRotate(originalSize, originalSize.rotate);
            outer = getFrameAfterRotate(nextSize, nextSize.rotate);
        }

        const calcSnapFlipH = () => ((!has(nextSize, 'flipH') || !has(elementModel, 'props.style.flipH') || get(nextSize, 'flipH') === get(elementModel, 'props.style.flipH')) ? 0 : -1);
        const calcSnapFlipV = () => ((!has(nextSize, 'flipV') || !has(elementModel, 'props.style.flipV') || get(nextSize, 'flipV') === get(elementModel, 'props.style.flipV')) ? 0 : -1);
        const snapFlipH = calcSnapFlipH();
        const snapFlipV = calcSnapFlipV();
        const hasSnap = () => snapFlipH !== -1 && snapFlipV !== -1;
        mode = constraints.getFlipMode(snapFlipH, snapFlipV, mode);

        let lines = [];

        if (mutiRect?.length > 1) {
            if (hasSnap()) {
                const operateRect = {
                    left: (outer.left - original.left + mutiRect.left),
                    top: (outer.top - original.top + mutiRect.top),
                    width: (outer.width - original.width + mutiRect.width),
                    height: (outer.height - original.height + mutiRect.height),
                };
                lines = this.runConstraints(operateRect, mode);
                SnaplineLogic.caculateFrame4m(e, mode, lines, outer, original, offsetFrame, operateRect);
            }
        } else {
            // 选中页面元素进行操作
            if (this.isSingleGroupSelected()) {
                const operateRect = {
                    left: (outer.left - original.left + mutiRect.left),
                    top: (outer.top - original.top + mutiRect.top),
                    width: (outer.width - original.width + mutiRect.width),
                    height: (outer.height - original.height + mutiRect.height),
                };
                // step5 计算命中的辅助线
                lines = this.runConstraints(operateRect, mode);
                const adsorptionParams = {
                    e, lines, mode, nextSize, offsetFrame, original: mutiRect,
                    outer: operateRect, rotate: elementModel?.props?.style.rotate, elementModel,
                };
                SnaplineLogic.caculateFrame(adsorptionParams);
            } else {
                // 单选非组合元素或者单选组合里面的元素进行操作
                // step5 计算命中的辅助线
                const { rotate } = elementModel?.props?.style || {};
                const { newLines, newMode } = this.getSingleEleLines(outer, mode, rotate, nextSize);
                if (mode === MODES.MOVE && isGroupChildren) {
                    // 组合翻转的情况下，移动组合出现对齐线，此处需要去掉翻转属性
                    offsetFrame = {
                        left: offsetFrame.left,
                        top: offsetFrame.top,
                        width: offsetFrame.width,
                        height: offsetFrame.height,
                    };
                }
                const adsorptionParams = {
                    e, lines: newLines, mode: newMode, nextSize, offsetFrame,
                    original, outer, rotate, elementModel,
                };
                // step6 修改offsetFrame
                SnaplineLogic.caculateFrame(adsorptionParams);
            }
        }
        return offsetFrame;
    };

    getSelectionService() {
        return AppServiceProvider.getInstance().getAppServices().viewableServiceLayer?.selectionService;
    }

    getUiDataService() {
        return AppServiceProvider.getInstance().getAppServices()
            .getUiDataService();
    }
}
